import { isNonNullable } from './isNonNullable';

/**
 * Create type guard determining subtype by property presence
 *
 * @example
 * type Cat = Animal & {meow: () => void};
 * const isCat = makeTypeGuardByProperty<Animal, Cat>('meow');
 */
export const makeTypeGuardByProperty =
  <TBase, TChild extends TBase>(prop: keyof TChild) =>
  (value: TBase | null | undefined): value is TChild =>
    isNonNullable(value) && Object.prototype.hasOwnProperty.call(value, prop);
